// console.log(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
// export const STRIPE_PUBLISHABLE_KEY: string = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
// const env = window.__ENV__;
interface ConfigType {
  STRIPE_PUBLISHABLE_KEY: string;
}

export async function getStripePublishableKey() {
  try {
    // const baseUrl = process.env.PUBLIC_URL || "/";
    const configResponse = await fetch(`/api/config.json`);

    if (configResponse.ok) {
      const config = await configResponse.json();
      console.debug({
        env: process.env,
        config,
      });
      const STRIPE_PUBLISHABLE_KEY: string = (config as unknown as ConfigType).STRIPE_PUBLISHABLE_KEY;
      return STRIPE_PUBLISHABLE_KEY;
    } else {
      throw new Error(`Response status: ${configResponse.status}`);
    }
  } catch (error: unknown) {
    console.error({
      error,
    });
  }
}
